var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16c8.838 0 16-7.164 16-16S24.838 0 16 0z","fillOpacity":".4","fill":"#000","key":0}),React.createElement("path",{"fill":"#FFF","d":"M13.243 21.973V9.586L22 15.78z","key":1})]));
}

Play.defaultProps = {"width":"32","height":"32"};

module.exports = Play;

Play.default = Play;
